export const ACCEPTED_FILE_TYPES = {
  'application/gzip': ['.gz'],
  'application/json': ['.json'],
  'application/proto': ['.pb', '.pprof'],
};
